import React, { memo, useEffect, useState } from "react";
import Dashboard from "../../Dashboard/Dashbard";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { ActivityLogsDataView } from "./ActivityLogsDataView";
import Loader from "../../../../components/common/Loader";
import { TabButtons } from "../../../../components/common/TabButtons/TabButtons";
import routesObj from "../../../../routes/RoutesObj";

const AllUsersActivityLogs = () => {
    document.title = "OFish - Support FAQs";

    const history = useHistory();
  
    const [activeTabId, setActiveTabId] = useState(`0`);
  
    const RenderSection = memo(() => {
      switch (`${activeTabId}`) {
        case "0":
          return <ActivityLogsDataView activeTabId={activeTabId} setActiveTabId={setActiveTabId} />;

        default:
          return <h1>No Page Found!</h1>;
      }
    });
  
    return (
      <Dashboard className="gridBody contentBody businessCustomerGrid">
        <div className='body-content'>
          <div className='contentHeading'>
            <h1>Activity Logs</h1>
          </div>
          <TabButtons
                tabs={[
                { title: "All Activity Logs", to: routesObj.ActivityLogs.path },
                ]}
            />
          <RenderSection />
        </div>
      </Dashboard>
    );
};

export { AllUsersActivityLogs };
